import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';

// internal
import reducers from '@app/store/reducers';
import sagas from '@app/store/sagas';

declare var window: any;

const mode = process.env.NODE_ENV === 'production';
const sagaMiddleware = createSagaMiddleware();
const middlewares: any[] = [sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

if (mode && typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = () => {};
}

const store = createStore(
  reducers,
  compose(
    applyMiddleware(...middlewares),
    mode && window.devToolsExtension
      ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f: any) => f,
  ),
);

sagaMiddleware.run(sagas);

export default store;
